import { useMemo } from 'react';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2';
import { ProductListItem } from '../types/global';
import {
  filterProductsByUserStatus,
  filterProductsByApp,
  sortProductsByTier,
  getProductById,
} from '../utils/productUtils';

/**
 * Hook to access and filter products from the me response
 */
export const useProducts = () => {
  const { canvaAuthenticated } = useCanvaAuth();

  const productList = useMemo<ProductListItem[]>(() => {
    if (!canvaAuthenticated?.meResponse?.userProfile?.productList) {
      return [];
    }
    return canvaAuthenticated.meResponse.userProfile.productList;
  }, [canvaAuthenticated]);

  const activeProducts = useMemo(() => {
    return productList.filter((item) => item.is_active && item.product.is_active);
  }, [productList]);

  const sortedByTier = useMemo(() => {
    return sortProductsByTier(activeProducts);
  }, [activeProducts]);

  const getByUserStatus = (userStatus: 'NEW' | 'EXISTING' | string) => {
    return filterProductsByUserStatus(productList, userStatus);
  };

  const getByApp = (appName: string) => {
    return filterProductsByApp(productList, appName);
  };

  const getById = (productId: number) => {
    return getProductById(productList, productId);
  };

  return {
    productList,
    activeProducts,
    sortedByTier,
    getByUserStatus,
    getByApp,
    getById,
  };
};
